<template>
	<span :class="cn('relative inline-block py-1 pr-1 sm:pr-6', containerClass)">
		<span class="relative">
			<slot />
		</span>
		<span
			:class="
				cn(
					'absolute inset-0 -left-8 w-[112%] skew-x-[-20deg] bg-primary-light-4 sm:w-[105%] md:!-left-5 lg:w-[103%]',
					rectangleClass
				)
			"
			aria-hidden="true"
		></span>
	</span>
</template>

<script setup lang="ts">
import { cn } from '~/utils';

type Props = {
	containerClass?: string;
	rectangleClass?: string;
};

defineProps<Props>();
</script>
